// extracted by mini-css-extract-plugin
export var adding = "tile-module--adding--1aaff";
export var align_center = "tile-module--align_center--3d8b3";
export var align_left = "tile-module--align_left--7384f";
export var align_right = "tile-module--align_right--1a013";
export var alts = "tile-module--alts--2ec2f";
export var button = "tile-module--button--686c0";
export var callout = "tile-module--callout--9cebd";
export var callouts = "tile-module--callouts--d0eeb";
export var color = "tile-module--color--6f424";
export var copy = "tile-module--copy--2154f";
export var cta = "tile-module--cta--52b5c";
export var disabled = "tile-module--disabled--cfee1";
export var grid_count = "tile-module--grid_count--de1e2";
export var image = "tile-module--image--8eee2";
export var images = "tile-module--images--ce06b";
export var img_placehold = "tile-module--img_placehold--77166";
export var info = "tile-module--info--5e1c1";
export var info_tile = "tile-module--info_tile--c900c";
export var infos = "tile-module--infos--1d000";
export var nd_ctaLink = "tile-module--nd_cta-link--9aa55";
export var page_tile = "tile-module--page_tile--fcf4e";
export var pdot = "tile-module--pdot--98428";
export var pkstory_content = "tile-module--pkstory_content--75fd6";
export var price = "tile-module--price--0ca3e";
export var ptPriceFull = "tile-module--pt-price-full--dad81";
export var ptPriceLow = "tile-module--pt-price-low--da1f6";
export var ptPricePercent = "tile-module--pt-price-percent--f96ee";
export var qsizes_desk = "tile-module--qsizes_desk--15c58";
export var qstore_label = "tile-module--qstore_label--ac6f2";
export var quick_desk = "tile-module--quick_desk--1d795";
export var quick_mob = "tile-module--quick_mob--84afb";
export var qview = "tile-module--qview--61dd7";
export var qview_mob = "tile-module--qview_mob--31cd3";
export var tile = "tile-module--tile--a0fbb";
export var tile2 = "tile-module--tile2--658fb";
export var tile_link = "tile-module--tile_link--60ed5";
export var tile_title = "tile-module--tile_title--42269";
export var title = "tile-module--title--444ad";
export var vinfo_data = "tile-module--vinfo_data--91a1b";
export var vinfo_label = "tile-module--vinfo_label--f321c";
export var vinfos = "tile-module--vinfos--a6c86";
export var vsold = "tile-module--vsold--8fafa";